module.exports = __webpack_public_path__ + "img/house_ev_error_online.f8a1d5bd.png";